import type { RouteRecordRaw } from 'vue-router'

const ISPAppRoute: RouteRecordRaw = {
  path: '/ISP-App',
  name: 'ISPApp',
  meta: {},
  component: async () => await import('@/views/ISPApp/layout.vue'),
  children: [
    {
      path: '', // 空路徑表示默認路由
      name: 'ISPAppHome',
      meta: {
        title: 'ISP App 首頁'
      },
      component: async () => await import('@/views/ISPApp/pages/Home.vue')
    },
    {
      path: 'login',
      name: 'ISPAppLogin',
      meta: {
        title: '登入'
      },
      component: async () => await import('@/views/ISPApp/pages/auth/Login.vue')
    },
    {
      path: 'consultation',
      name: 'ISPAppConsultation',
      meta: {
        title: '一鍵諮詢'
      },
      component: async () => await import('@/views/ISPApp/pages/consultation/Consultation.vue')
    },
    {
      path: 'suspend-apply',
      name: 'ISPAppSuspendApply',
      meta: {
        title: '暫停申請'
      },
      component: async () => await import('@/views/ISPApp/pages/consultation/SuspendApply.vue')
    },
    {
      path: 'suspend-time-set',
      name: 'ISPAppSuspendTimeSet',
      meta: {
        title: '暫停設定'
      },
      component: async () => await import('@/views/ISPApp/pages/consultation/SuspendTimeSet.vue')
    },
    {
      path: 'suspend-modify',
      name: 'ISPAppSuspendModify',
      meta: {
        title: '異動申請'
      },
      component: async () => await import('@/views/ISPApp/pages/consultation/SuspendModify.vue')
    },
    {
      path: 'contact-us',
      name: 'ISPAppContactUs',
      meta: {
        title: '我的客服'
      },
      component: async () => await import('@/views/ISPApp/pages/contact/ContactUs.vue') // Adjust path as needed
    },
    {
      path: 'call-service',
      name: 'ISPAppCallService',
      meta: {
        title: '直撥客服'
      },
      component: async () => await import('@/views/ISPApp/pages/contact/CallService.vue') // Adjust path as needed
    },
    {
      path: 'email-service',
      name: 'ISPAppEmailService',
      meta: {
        title: '客服信箱'
      },
      component: async () => await import('@/views/ISPApp/pages/contact/EmailService.vue') // Adjust path as needed
    },
    {
      path: 'location-service',
      name: 'ISPAppLocation',
      meta: {
        title: '服務據點'
      },
      component: async () => await import('@/views/ISPApp/pages/contact/Location.vue') // Adjust path as needed
    },
    {
      path: 'info-search',
      name: 'ISPAppInfoSearch',
      meta: {
        title: '帳務查詢'
      },
      component: async () => await import('@/views/ISPApp/pages/account/InfoSearch.vue')
    }
  ]
}

export default ISPAppRoute